import React, { PropsWithChildren, useEffect, useState } from 'react';
import classNames from './style.module.scss';

import Conditional from '../../../common/conditional';
import Confirm from '../../../themed/confirm';

interface Props extends PropsWithChildren {
    isOpenOnDefault: boolean;
    title: string;
    onEdit: () => void;
    onDelete: () => void;
}

const CustomGroupItem: React.FC<Props> = ({ children, isOpenOnDefault, onEdit, onDelete, title }) => {
	const [deleteItem, setDeleteItem] = useState(false);
	const [isOpen, setOpen] = useState(false);
    
	const handleToggleDeletion = () => {
		setDeleteItem((previous) => !previous);
	};

    useEffect(() => {
		if (isOpenOnDefault) setOpen(isOpenOnDefault);
	}, [isOpenOnDefault]);

    return ( 
        <>
            <Conditional isVisible={deleteItem}>
                <Confirm
                    title={'Delete Item?'}
                    message="Are you sure you want to delete this item? This action is not reversible!"
                    onCancel={handleToggleDeletion}
                    onConfirm={onDelete}
                />
            </Conditional>
            
			<Conditional isVisible={!deleteItem}>
                <div className={classNames.customGroupItem}>
                    <div
                        className={classNames.customGroupItemHeader}
                        onClick={() => setOpen((prev) => !prev)}
                        role="button"
                    >
                        <div>{title}</div>

                        <div className="d-flex justify-content-center align-items-center">
                            <button
                                className={classNames.customGroupItemEdit}
                                onClick={onEdit}
                            >
                                <i className="bi bi-pencil"></i>
                            </button>

                            <button
                                className={classNames.customGroupItemDelete}
                                onClick={handleToggleDeletion}
                            >
                                <i className="bi bi-trash"></i>
                            </button>

                            <div className={classNames.customGroupItemIcon}>
                                <i className={`bi bi-chevron-${isOpen ? 'down' : 'right'}`}></i>
                            </div>
                        </div>
                    </div>

                    <Conditional isVisible={isOpen}>
                        <div className={classNames.customGroupItemBody}>
                            {children}
                        </div>
                    </Conditional>
                </div>
            </Conditional>
        </>
     );
}
 
export default CustomGroupItem;